module.exports = __webpack_public_path__ + "img/indr.e9182b78.png";